export default __webpack_public_path__ + "static/media/pic12.ca340604.jpg";